interface MainCardProps {
  disabled?: boolean;
  children?: React.ReactNode;
  className?: string;
}

function MainCard({ children, className, disabled = false }: MainCardProps) {
  return (
    <div className={`relative h-full w-full`}>
      {disabled && (
        <div className='absolute left-0 top-0 z-10 h-full w-full bg-color-lightest/50 rounded-lg' />
      )}
      <main
        className={`
          w-full rounded-lg px-4 py-8 shadow-level-2 lg:px-8 
          ${disabled ? 'bg-button-color-primary-disabled' : 'bg-color-lightest'}
          ${className}
        `}
      >
        {children}
      </main>
    </div>
  );
}

export { MainCard };
